module.exports = __webpack_public_path__ + "static/media/screenshot(8).0f12d7ac.jpg";